import { render, staticRenderFns } from "./MapNavigationLayer.vue?vue&type=template&id=7815fa55&"
import script from "./MapNavigationLayer.vue?vue&type=script&lang=js&"
export * from "./MapNavigationLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MapNavigationBackButton: require('/srv/rir-platform/tourism/src/tourism-front/components/common/MapNavigation/MapNavigationBackButton.vue').default,InputComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/InputComponent/index.vue').default,ImageComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/ImageComponent/index.vue').default,LayerNote: require('/srv/rir-platform/tourism/src/tourism-front/components/common/LayerNote/index.vue').default,EmptyEntity: require('/srv/rir-platform/tourism/src/tourism-front/components/common/EmptyEntity/index.vue').default})
